document.addEventListener("DOMContentLoaded", function() {
  const barCharts = document.querySelectorAll("#specs .bar");
  if (barCharts.length > 0) {
    barCharts.forEach((bar) => {
      const checking = setInterval(function() {
        if (isScrolledIntoView(bar)) {
          clearInterval(checking);
          animateBarChart(bar);
        }
      }, 500);
    });
  }
});
function isScrolledIntoView(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
function animateBarChart(barElement) {
  const barValue = barElement.querySelector(".val").getAttribute("databarchart");
  const barNumber = barValue.replace(/[^0-9]/g, "");
  barElement.querySelector(".val").style.width = barNumber + "%";
}
